import React from 'react';
import { connectWithStore } from '@react/Common/connectWithStore';
import { getUserPermissionsState, saveAppPermissions } from '@redux/ducks/userPermissions/userPermissions';
import { CustomUserPermissions } from './CustomUserPermissions/CustomUserPermissions';
import { ChangeAppAccess } from './ChangeAppRole';

const Header = ({ title }) => (
  <div className="content-title-box without-background">
    <div className="flex-auto">
      <h3 className="content-heading">{title}</h3>
    </div>
  </div>
);

export const AppAccessPageComponent = ({ onCancel, isCustomRole, currentApp, onSubmit, submitEnabled }) => (
  <div className="content content-panel flex-one flex-box-column">
    <Header title={currentApp.name} />

    <div className="content-inner flex-one flex-box-column">
      <ChangeAppAccess />

      {isCustomRole ? <CustomUserPermissions /> : <div className="content panel-content flex-one" />}

      <div className="content panel-content flex-auto">
        <div className="panel-footer flex-auto">
          <div className="flex-box-row">
            <button onClick={onCancel} className="btn flex-one">
              {t('action.back')}
            </button>
            <button disabled={!submitEnabled} onClick={onSubmit} className="btn btn-main flex-one">
              {t('action.apply')}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/**
 * NOTE: the "Apply" button should be disabled if no trackers are selected,
 * regardless if any partner is selected. No trackers – no Save.
 * More info: https://adjustcom.atlassian.net/browse/ASC-833
 */
const arePartnersValid = currentApp => {
  const hasPartners = currentApp?.access?.partners?.length > 0;
  const hasTrackers = currentApp?.access?.trackers?.length > 0;

  return (hasPartners && hasTrackers) || !hasPartners;
};

const mapStateToProps = state => {
  const { currentApp, canApplyAppPermissions } = getUserPermissionsState(state);
  const partnerList = currentApp?.access?.partners || [];
  const trackerList = currentApp?.access?.trackers || [];

  const enabledRoleItem = item => item.role;

  const isCustomRole = currentApp?.access?.role === 'custom';
  const isCustomPermissionSet = partnerList.some(enabledRoleItem) || trackerList.some(enabledRoleItem);
  const shouldSubmitCustomApp = isCustomRole ? isCustomPermissionSet : true;
  const submitEnabled = shouldSubmitCustomApp && canApplyAppPermissions && arePartnersValid(currentApp);

  return { currentApp, submitEnabled, isCustomRole };
};

const mapStateToDispatch = {
  onSubmit: saveAppPermissions,
};

export const AppAccessPage = connectWithStore(mapStateToProps, mapStateToDispatch)(AppAccessPageComponent);
